import axios from 'axios';
import Cookies from "universal-cookie";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

function getToken() {
  const cookies = new Cookies();
  const token = cookies.get("token");
  
  // Note: Laravel Sanctum tokens are not JWTs, so we skip format validation
  // Basic XSS protection only
  if (token && (token.includes('<script') || token.includes('javascript:'))) {
    console.warn('Suspicious token content detected, removing token');
    return null;
  }
  
  return token;
}

/**
 * Get all research questions for a project
 */
export const getResearchQuestions = async (projectUuid) => {
    try {
        const response = await axios.get(`${API_BASE}/project/${projectUuid}/research-questions`, {
            headers: {
                authorization: `Bearer ${getToken()}`
            }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

/**
 * Create a manual research question
 */
export const createResearchQuestion = async (projectUuid, questionData) => {
    try {
        const response = await axios.post(`${API_BASE}/project/${projectUuid}/research-questions`, questionData, {
            headers: {
                authorization: `Bearer ${getToken()}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

/**
 * Update a research question
 */
export const updateResearchQuestion = async (projectUuid, questionUuid, questionData) => {
    try {
        const response = await axios.put(`${API_BASE}/project/${projectUuid}/research-questions/${questionUuid}`, questionData, {
            headers: {
                authorization: `Bearer ${getToken()}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

/**
 * Delete a research question
 */
export const deleteResearchQuestion = async (projectUuid, questionUuid) => {
    try {
        const response = await axios.delete(`${API_BASE}/project/${projectUuid}/research-questions/${questionUuid}`, {
            headers: {
                authorization: `Bearer ${getToken()}`
            }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

/**
 * Generate AI suggestions for research questions
 */
export const generateAISuggestions = async (projectUuid, formResponses, language) => {
    try {
        const response = await axios.post(`${API_BASE}/project/${projectUuid}/research-questions/generate-ai`, {
            form_responses: formResponses,
            language: language
        }, {
            headers: {
                authorization: `Bearer ${getToken()}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

/**
 * Select and save one of the AI suggestions
 */
export const selectAISuggestion = async (projectUuid, questionUuid, suggestionData) => {
    try {
        const response = await axios.post(`${API_BASE}/project/${projectUuid}/research-questions/${questionUuid}/select-suggestion`, suggestionData, {
            headers: {
                authorization: `Bearer ${getToken()}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};